const SET_ORGANISATION = (state, data) => {
  state.organisation = data
}

export default {
  SET_ORGANISATION
}
